import { Link } from "react-router";
import { consentStore, decide } from "../lib/consent.ts";

/** Asks once; "Cookie settings" in the footer brings it back. Rejecting is as easy as accepting. */
export function CookieBanner() {
  const open = consentStore.use((c) => !c.decidedAt || c.reopened === true);
  if (!open) return null;
  return (
    <section className="cookiebar" aria-labelledby="cookiebar-title" aria-live="polite">
      <div className="cookiebar__text">
        <h2 id="cookiebar-title">Cookies</h2>
        <p>
          We use essential cookies to keep you signed in, remember your bag and take payment with
          PayPal. Optional cookies, like analytics, are only used if you accept.{" "}
          <Link to="/cookies">Cookie policy</Link>
        </p>
      </div>
      <div className="cookiebar__actions">
        <button type="button" className="btn btn--white btn--sm" onClick={() => decide(false)}>
          Essential only
        </button>
        <button type="button" className="btn btn--sm" onClick={() => decide(true)}>
          Accept all
        </button>
      </div>
    </section>
  );
}
